import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllCarModelsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  nameIcontains?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllCarModelsQuery = { __typename?: 'Query', allCarModels?: { __typename?: 'CarModelNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CarModelNodeEdge', cursor: string, node?: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null } | null } | null> } | null };


export const AllCarModelsDocument = gql`
    query AllCarModels($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $nameIcontains: String) {
  allCarModels(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    nameIcontains: $nameIcontains
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        name
        localName
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllCarModelsQuery__
 *
 * To run a query within a React component, call `useAllCarModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarModelsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      nameIcontains: // value for 'nameIcontains'
 *   },
 * });
 */
export function useAllCarModelsQuery(baseOptions?: Apollo.QueryHookOptions<AllCarModelsQuery, AllCarModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCarModelsQuery, AllCarModelsQueryVariables>(AllCarModelsDocument, options);
      }
export function useAllCarModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCarModelsQuery, AllCarModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCarModelsQuery, AllCarModelsQueryVariables>(AllCarModelsDocument, options);
        }
export type AllCarModelsQueryHookResult = ReturnType<typeof useAllCarModelsQuery>;
export type AllCarModelsLazyQueryHookResult = ReturnType<typeof useAllCarModelsLazyQuery>;
export type AllCarModelsQueryResult = Apollo.QueryResult<AllCarModelsQuery, AllCarModelsQueryVariables>;